<div class="page-container">
  <div class="page-title-block">
    <div class="page-type">Picker Page</div>
    <div class="more-info-btn" (click)="openMoreInfo()">More info</div>
  </div>
  <ng-container *ngTemplateOutlet="pickerPagesForm"></ng-container>
  <div class="more-info-container" [ngClass]="{ 'open': moreInfoOpened }">
    <div class="close-btn-block">
      <button class="close-btn" (click)="closeMoreInfo()">Close</button>
    </div>
    <div class="title">Picker Page</div>
    <img src="../../../../../../../../../../assets/img/ABF_more_info/pickerPage.jpg" alt="More info">
    <div class="desc">A picker page allows a user to select a single option from a scrollable pre-confirgured list. </div>
    <div class="desc eg">E.G. selecting a country from a list</div>
  </div>
</div>


<ng-template #pickerPagesForm>
  <div class="page-content">
    <ng-container [formGroup]="pickerPageForm">
      <div class="fields-block">
        <div class="form-field-block">
          <div class="label-container">
            <label class="label">Page Header</label>
            <label class="optional">Optional</label>
          </div>
          <input class="input-field" placeholder="Enter page header" [formControlName]="'pageHeader'" (ngModelChange)="setPageDataHandler()"/>
        </div>
        <div class="form-field-block">
          <div class="label-container">
            <label class="label">Page Subheader</label>
          </div>
          <input class="input-field" placeholder="Enter subheader" [formControlName]="'pageSubHeader'"/>
          <input-validators controlName="pageSubHeader" [control]="pickerPageForm.controls['pageSubHeader']"></input-validators>
        </div>
        <div class="form-field-block">
          <div class="label-container">
            <label class="label">Picker Title</label>
            <label class="optional">Optional</label>
          </div>
          <input class="input-field" placeholder="Enter picker title" [formControlName]="'pickerText'"/>
        </div>
        <span class="line"></span>
      </div>
    </ng-container>
    <div class="options-block">
      <div class="add-option-block">
        <button class="add-option-btn" (click)="addOption()">Add Option</button>
        @if (pickerPageFormOptions.value.length > 0) {
          <div class="options-count">
            {{ pickerPageFormOptions.value.length }} {{ pickerPageFormOptions.value.length > 1 ? 'options' : 'option' }}
          </div>
        }
      </div>
      <div class="options-list" (cdkDropListDropped)="dropOption($event)" cdkDropList>
        @for (pickerOption of pickerPageFormOptions.controls; track pickerOption; let index = $index) {
          <div cdkDrag>
            <div class="custom-placeholder" *cdkDragPlaceholder></div>
            <div class="option-item">
              <div class="fields">
                <div id="option-{{index}}" [formGroup]="pickerOption">
                  <input [formControlName]="'identifier'" hidden/>
                  <div class="form-field-block option-field option-title">
                    <input class="input-field" placeholder="Option title" [formControlName]="'text'"/>
                    <input-validators controlName="text" [control]="pickerOption.controls['text']"></input-validators>
                  </div>
                  <div class="form-field-block option-field">
                    <input class="input-field" placeholder="Value (e.g. Product Code/SKU/Unique ID)" [formControlName]="'value'"/>
                    <input-validators controlName="value" [control]="pickerOption.controls['value']"></input-validators>
                  </div>
                </div>
                <div class="form-field-block" [formGroup]="pickerPageForm">
                  <label class="label">
                    <input class="checkbox" type="radio" name="selectedItemIndex" [value]="index" [formControlName]="'selectedItemIndex'" [checked]="pickerPageForm.value.selectedItemIndex === index"/>
                    <span class="checkbox-styled"></span>
                    <span class="label-text">Set as default</span>
                  </label>
                </div>
              </div>
              <div class="controls">
                <div class="move-btn" cdkDragHandle></div>
                <div class="remove-btn" [matTooltip]="'Minimum 1 option required'"
                  matTooltipClass="menu-form-option-remove-btn-toolTip" matTooltipPosition="above"
                  [matTooltipDisabled]="pickerPageFormOptions.controls.length > 1"
                  [ngClass]="{'disabled-btn' : pickerPageFormOptions.controls.length === 1} "
                (click)="removeOption(index)"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
